import { reactive } from 'vue';

export const store = reactive({
  productOfTradeCollection: [],
  aberturaCaixa: false,
  fechamentoAsCegas: false,
  verificaEstoque: false,
  pafNFCe: false,
});
